module.exports = __webpack_public_path__ + "img/gearHelper_w.5703502b.svg";